import { render, staticRenderFns } from "./deviceMagtIndex.vue?vue&type=template&id=76d7dbe2"
import script from "./deviceMagtIndex.vue?vue&type=script&lang=js"
export * from "./deviceMagtIndex.vue?vue&type=script&lang=js"
import style0 from "./deviceMagtIndex.vue?vue&type=style&index=0&id=76d7dbe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports